import { ClipboardList, Hammer, CheckCheck, Package } from "lucide-react";
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Dashboard() {
  const [summary, setSummary] = useState({
    initial_jobsheet_count: 0,
    production_count: 0,
    qc_count: 0,
    rework_count: 0,
    total_active: 0,
  });

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await axios.get(
          "https://eps.elkomprintama.com/get/api/dashboard",
        );
        console.log(res.data);
        setSummary(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchSummary();
  }, []);

  return (
    <>
      <div className="grid grid-cols-5 gap-4 p-4">
        <div className="bg-blue-500 text-white p-4 rounded-xl shadow-lg flex items-center">
          <ClipboardList className="w-8 h-8 mr-3" />
          <div>
            <h3 className="text-lg font-semibold">Jobsheet</h3>
            <p className="text-2xl font-bold">
              {summary.initial_jobsheet_count}
            </p>
          </div>
        </div>
        <div className="bg-green-500 text-white p-4 rounded-xl shadow-lg flex items-center">
          <Hammer className="w-8 h-8 mr-3" />
          <div>
            <h3 className="text-lg font-semibold">Production</h3>
            <p className="text-2xl font-bold">{summary.production_count}</p>
          </div>
        </div>
        <div className="bg-yellow-500 text-white p-4 rounded-xl shadow-lg flex items-center">
          <CheckCheck className="w-8 h-8 mr-3" />
          <div>
            <h3 className="text-lg font-semibold">QC</h3>
            <p className="text-2xl font-bold">{summary.qc_count}</p>
          </div>
        </div>
        <div className="bg-red-500 text-white p-4 rounded-xl shadow-lg flex items-center">
          <CheckCheck className="w-8 h-8 mr-3" />
          <div>
            <h3 className="text-lg font-semibold">Rework</h3>
            <p className="text-2xl font-bold">{summary.qc_count}</p>
          </div>
        </div>
        <div className="bg-purple-500 text-white p-4 rounded-xl shadow-lg flex items-center">
          <Package className="w-8 h-8 mr-3" />
          <div>
            <h3 className="text-lg font-semibold">Total Active</h3>
            <p className="text-2xl font-bold">{summary.total_active}</p>
          </div>
        </div>
      </div>
    </>
  );
}
